<template>
  <v-card>
    <v-card-title>customer所属</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="customer名"
              v-model="data.name"
              required
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="d-flex" v-for="(jdev, i) in JoinDevelopers" :key="i">
              <p>{{ JoinDevelopers[i].ID }}:{{ JoinDevelopers[i].name }}</p>
              <v-spacer></v-spacer>
              <v-btn class="d-flex" color="success" @click="move1(i)">
                脱退
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="d-flex" v-for="(dev, i) in Developers" :key="i">
              <p>{{ Developers[i].ID }}:{{ Developers[i].name }}</p>
              <v-spacer></v-spacer>
              <v-btn class="d-flex" color="success" @click="move2(i)">
                参加
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <!--
        <v-row>
          <div>
            <v-col cols="12" class="d-flex">
              <v-select
                v-model="Jdev"
                :items="JoinDevelopers"
                item-text="name"
                item-value="ID"
                label="参加済み"
                return-object
              ></v-select>
              <v-col cols="1" class="d-flex">
                <v-btn class="d-flex" color="success" @click="move1(Jdev)"
                  >脱退</v-btn
                >
              </v-col>
            </v-col>
          </div>
        </v-row>
        -->
        <!--
        <v-row>
          <div>
            <v-col cols="12" class="d-flex">
              <v-select
                v-model="dev"
                :items="Developers"
                item-text="name"
                item-value="ID"
                label="未参加"
                return-object
              ></v-select>
              <v-col cols="1" class="d-flex">
                <v-btn color="success" @click="move2">参加</v-btn>
              </v-col>
            </v-col>
          </div>
        </v-row>
        -->
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      returnData: {},
      Developers: [],
      JoinDevelopers: [],
      dev: {},
      Jdev: {},
    };
  },
  async mounted() {
    await this.getInit();
  },
  methods: {
    async getInit() {
      const data = await api.getJoinDeveloper(this.data.ID);
      this.Developers = data.Developers;
      this.JoinDevelopers = data.JoinDevelopers;
    },
    async submit() {
      let data = {};
      data.Developers = this.Developers;
      data.JoinDevelopers = this.JoinDevelopers;
      data.CustomerID = this.data.ID;
      await api.regJoinDeveloper(data);

      this.$emit("clickSubmit", this.returnData);
    },
    move1(index) {
      //データの追加と削除を実行
      let tmp = this.JoinDevelopers.splice(index, 1);
      this.Developers.push(tmp[0]);
      //this.Developers.push(this.JoinDevelopers.splice(index, 1));
    },
    move2(index) {
      //データの追加と削除を実行
      let tmp = this.Developers.splice(index, 1);
      this.JoinDevelopers.push(tmp[0]);
    },
  },
};
</script>
